import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reservation",
  "use": "icon-reservation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reservation\"><path fill=\"#bfcbd9\" d=\"M885.8 512c0 12.8 10.3 23.1 23.1 23.1s23.1-10.4 23.1-23.1c0-231.6-188.4-420-420-420s-420 188.4-420 420 188.4 420 420 420c95.1 0 186.6-32.6 259.9-90.2l51.9 46c6.8 6 15.4 9.1 24.6 9.1 5.3 0 10.7-1 16.1-3.1 19.1-7.3 33.3-25.4 35.5-45.1l18-163.9c1.4-13.1-2.9-25.3-12-33.3-9.1-8.1-21.7-10.9-34.5-7.9L711 681.3c-19.2 4.5-35.5 20.9-40.5 40.7-3.9 15.3 0.2 30.1 10.9 39.6l55.3 49c-64.1 48.1-142.9 75.2-224.7 75.2-206.1 0-373.8-167.7-373.8-373.8S305.9 138.2 512 138.2s373.8 167.7 373.8 373.8z\" /><path fill=\"#bfcbd9\" d=\"M512 235.7c-7.6 0-13.8 6.2-13.8 13.8v262.8c0 5 2.7 9.5 7 12l168.9 97c2.2 1.2 4.6 1.8 6.9 1.8 4.8 0 9.5-2.5 11.9-6.9 3.8-6.6 1.5-15.1-5.1-18.9l-162-93V249.5c0-7.6-6.2-13.8-13.8-13.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/reservation.svg
// module id = AWon
// module chunks = 87